<template>
  <svg ref="svgElement" :viewBox="viewBox">
    <path
      v-for="c in children"
      :key="c.id"
      :class="[
        $style.shopArea,
        {
          [$style.isActive]: isActive(c),
          [$style.isSelected]: modelValue === c.id,
        },
      ]"
      :d="d(c)"
      @click="$emit('update:modelValue', c.id)"
      @mouseover="hoverEffectToggle(c.id, true)"
      @mouseout="hoverEffectToggle(c.id, false)"
    />
    <path
      v-if="showBp"
      :class="$style.shopArea"
      d="m 499.7,250.2 c 0.9,1.5 1.3,2.7 2.7,3.9 3.5,2.9 5,4.6 4.8,9.9 -0.4,9 -2.9,7.9 -5.8,9.9 -0.7,0.5 -1.1,1.2 -1.9,1.5 -0.6,0.2 -1.4,0 -2,0.1 -3,0.8 -2.7,4.7 -4.5,6.7 -4.9,5.4 -2.9,4.7 -4.2,7.4 -1.2,2.5 -5.3,1.6 -7.3,1.1 -8.1,-2.2 -3.6,-11.5 -9.7,-10.8 -1.6,0.2 -2.1,1.2 -3,2.4 -2.4,2.8 -5.5,-0.2 -7.3,-0.1 -3.8,0.1 -4.3,3.6 -6.9,3.5 -1.5,-0.1 -2.4,-1.3 -1.8,-2.8 0.3,-0.8 1.3,-1.1 1.6,-1.9 0.6,-1.4 -0.8,-4.1 -0.4,-5.7 0.4,-1.5 1.9,-2.4 2.5,-3.7 0.5,-1.1 0.1,-2.6 0.1,-3.8 -0.1,-1.2 0.2,-2.7 -0.2,-3.9 -0.5,-1.5 -2.1,-1.6 -3.3,-2.3 -3.6,-2.1 -2.2,-7 -3.7,-11.4 -0.6,-1.8 -0.6,-2.3 0.4,-3.9 1.2,-1.8 0.7,-2.2 -0.3,-3.8 -0.9,-1.4 0,-2.9 1.6,-3.3 3.9,-0.8 9,1.2 12.9,-4.8 2.4,-3.6 4.9,-1.9 7.2,-1.7 2.6,0.3 5.2,-2.3 7.5,-0.6 2.5,1.9 3.3,4.5 5,6.9 0.9,1.3 2.5,1.8 3.3,3.1 0.8,1.4 0.3,2.7 1.6,3.8 4.2,3.9 8.4,-0.2 11.1,4.3 z"
      style="fill: #DF1F26;"
      @click="$emit('update:modelValue', '1')"
    />
    <path
      v-if="showDuna"
      id="duna"
      d="M 374.6 607.5 c 0 0 -4.9 4.3 -8.3 9.4 c -3.4 5 -3.3 5.4 -6.6 11.6 c -3 5.9 -4.9 9.9 -4.9 10.8 c -0.1 -0.3 -0.9 -5.8 1.1 -12.7 c 2.1 -7.1 5.6 -13.1 5.6 -13.1 l -3.5 0 c 0 0 -3.6 6.7 -5.5 15.5 c -3.7 17.4 -4.7 32.3 -7.5 49.8 c 0 0 -10.8 6.3 -14.7 15.6 c -2.7 8.4 -0.2 12.8 -1.9 21.9 c -1.7 9.2 -3.5 6.5 -5.2 14.4 c -1.6 7.9 -0.1 10.9 -0.2 18.3 c 0 7.4 0.1 18.3 4 24.5 c 4.5 7 7.2 13.1 13.3 18.8 c 6.1 5.7 5 9.5 6.4 14.8 c 1.3 4.8 -5.6 14.3 -5.6 14.3 l 4.3 -9.4 l -3.8 -1.4 c 0.4 2.6 -0.3 6.5 -2.7 13.2 c -2.3 6.5 -4.6 6.6 -6.1 13.4 c -1.4 6.2 -0.2 9.1 -1 12.8 c -1.5 7.2 -4 9.1 -5.4 15.8 c -1.4 6.7 -0.1 5.1 -0.7 10.9 c -0.6 5.8 0.2 6.2 -2.6 12.9 c -2.8 6.7 -5.9 14.9 -8.1 18.3 c -2.2 3.5 -15.2 6.8 -15 6.4 c -0.2 -1.2 2 -6.6 6 -10.5 c 4.1 -3.9 9 -3.6 11.3 -4.5 l -0.5 -0.9 c 0 0 -5.9 1.7 -6.3 1.6 c -0.5 -0.2 4.1 -3.3 5.9 -3 l -0.4 -1.1 c -0.2 -0.3 -8.6 3.5 -12.7 9.3 c -4.3 5.3 -4.7 9.2 -4.7 9.3 c 0 0 -19.4 2.8 -31.6 8 c -11 4.7 -11.7 7.8 -17 13.2 c -5.3 5.4 -6.5 9.7 -6.5 9.7 l 7.5 0.2 c 0 0 14.3 -13.7 15.5 -14.4 c 6.5 -3.9 14.9 -5.7 24.7 -7.3 c 9.5 -1.5 20.1 -6.1 24.4 -10.1 c 6.3 -5.8 11.6 -14.6 14.7 -28.6 c 1.5 -6.6 0.6 -12.5 2.1 -18.2 c 2 -7.7 2.5 -6.6 3.6 -13.1 c 0.3 -2.1 0.5 -3.1 2.8 -3.1 c 1.3 0 3 0.2 3 0.2 l 0.2 -1.8 c -2.1 0.1 -4.7 -1.3 -5.5 1.8 c -0.1 -2.9 2.2 -6.8 4.5 -6.7 l 10 0.4 l -0.7 -1.3 c -3.7 -1.8 -9.6 -0.1 -9.4 -2.4 c 0.2 -2.4 9.4 -1.5 9.4 -1.5 l -0.3 -1.4 c 0 0 -8.1 -0.7 -9.5 0.2 c -1.2 0.8 -2 3.8 -3.1 5.7 c 0.1 0.1 -0.2 -5.7 2.3 -8.7 c 2 -2.4 10.1 -0.6 9.9 -1.3 l 0 -1.4 c -4.1 -0.5 -7.2 -0.5 -9.2 0.6 c 0 0 4.9 -13.8 11.4 -14.2 c 5.1 -0.3 11.6 9.7 12.3 13.8 c 0.8 4.5 1.5 2.9 2.9 14.1 c 0.1 0.5 -10.7 0.2 -10.7 0.2 l 0 1.3 c 0 0 10.7 -0.6 11.1 0.1 c 0.4 0.6 5.3 23.8 5.8 25.1 c 1.7 4.9 4 6.5 6.2 12.6 c 1.5 4.2 2.8 8.9 3.6 11.6 c 1.4 4.2 3.4 9.2 4.5 12.6 c 1.9 6.1 -7.5 17.1 -11.9 24.5 l 2.2 1.3 c 7.4 -11.9 12 -17.5 12.5 -28.9 c 0 -0.6 -0.1 -6.9 -2 -11.6 c -1 -2.4 -4.3 -8.2 -7.1 -10.7 c -1.1 -1 -6.1 -10.1 -6.8 -11.9 c -0.7 -1.8 -3.5 -17.7 -8.4 -40.8 c -0.8 -3.7 -6.7 -11.8 -10.1 -14 c -0.7 -0.4 -4.4 -1 -7.2 0.1 c 3.7 -5.5 3.3 -18.5 -1.6 -24.2 c -4.6 -5.4 -17 -18.9 -18 -27.9 c -0.8 -6.5 -2.2 -12.3 0.1 -19.9 c 0.9 -2.8 6.4 -13.6 7.3 -16.4 c 2 -5.8 3.3 -14.8 4.6 -19.3 c 1.1 -4 3.3 -5.3 4.8 -5.4 c 1.8 -0.1 3.5 -3.3 2.2 -3.3 l -1.5 0 c -1.1 2.2 -2.1 2.7 -3 3.4 c 0 0 1.8 -5.5 3.4 -7.8 c 1.7 -2.3 2.8 -0.8 3.3 -1.3 c 2.2 -2.3 6 -9.7 7.1 -12.2 c 2.9 -6.5 1.5 -12.1 0.5 -11.7 c -1.1 0.5 0.2 6.8 -2.3 11 c -1.5 2.5 -3.5 7.2 -8.3 12.8 c 0.2 -3.6 2.4 -6 4.6 -17.1 c 2 -9.8 1.6 -32.8 10.4 -44.6 c 6.9 -9.3 20.9 -27.1 20.7 -26.6 H 374.6 Z M 342.3 682.6 c 0.1 6.1 0.5 10.2 -9.8 30.4 c 0.1 -4 1.1 -7.7 1.7 -11.9 c -1.6 4.4 -3 8.8 -3.6 13.7 c -0.7 -7 -0.3 -12.3 1.3 -19.4 C 333.4 688.2 342.3 682.6 342.3 682.6 Z M 336.9 711.6 c -1.3 9.4 -1.1 14.6 -10.4 32.4 c 0 0 -2.8 -6.3 -0.4 -14.1 C 328.7 722.1 336.9 711.6 336.9 711.6 Z M 381.1 886.1 c 0 0 4.8 5.6 5.9 8.6 c 2.1 5.4 2.5 8.7 1.8 13.5 C 385.3 900.7 383.1 893.6 381.1 886.1 Z"
      style="fill: #89C1FF;"
    />
    <switch
      v-for="c in children"
      :id="uuid+c.id+'translation'"
      :key="c.id+'t'"
      :transform="sTransform(c)"
      :class="[
        $style.shopAreaText,
        {
          [$style.isActive]: isActive(c),
          [$style.isSelected]: modelValue === c.id,
          [$style.isNested]: !['', '233'].includes(modelValue),
        },
      ]"
      @click="$emit('update:modelValue', c.id)"
      @mouseover="hoverEffectToggle(c.id, true)"
      @mouseout="hoverEffectToggle(c.id, false)"
      v-html="tTextTranslated(c).outerHTML || null"
    />
  </svg>
</template>

<script>
  import { nextTick } from 'vue';
  import { uuid4 } from '~~/common/utils';
  import { PUSH_CLICK_MAP, CLICK_MAP_TYPE_AW_SHOP_AREA } from '~~/common/plugins/aw-analytics.js';
  import AuchanShopAreaSprite from '~~/shop/app/assets/icons/auchan-shop-area.svg';

  const NS = 'awshoparea';

  export default {
    name: 'AwAuchanShopAreaMap',
    props: {
      modelValue: {
        type: String,
        required: true,
      },
    },
    emits: [
      'update:modelValue',
      'change',
    ],
    data () {
      return {
        symbols: [],
        uuid: uuid4(),
        viewBox: '0 0 0 0',
      };
    },
    computed: {
      parentIds () {
        const path = this.getShopAreaById();
        const ids = [];
        const symbols = this.symbols;

        recursion(path);

        return ids;

        function recursion (recursedPath) {
          if (!recursedPath) {
            return;
          }

          const parentId = recursedPath.getAttribute(`${NS}:parentid`);

          ids.push(parentId);

          const parentPath = symbols
            .find(e => e.id === parentId)
          ;
          recursion(parentPath);
        }
      },
      showBp () {
        return this.modelValue === '' || (this.parentIds.length === 1 && this.parentIds[0] === '' && !this.isActive(this.getShopAreaById(this.modelValue)));
      },
      showDuna () {
        return this.modelValue === '1' || this.parentIds.includes('1');
      },
      children () {
        if (this.symbols.length === 0) {
          return [];
        }
        const newChildren = this.getChildrenById(this.modelValue);
        if (newChildren.length) {
          return newChildren;
        } else {
          const parentId = this.getShopAreaById().getAttribute(`${NS}:parentid`);
          return this.getChildrenById(parentId);
        }
      },
    },
    watch: {
      modelValue (newVal) {
        this.reCalcViewBox(newVal);

        const path = this.getShopAreaById(newVal);
        if (!path) {
          this.$emit('change', {
            postcodes: [],
            title: '',
          });
        } else {
          const postcodes = path.getAttribute(`${NS}:postcodes`).split('|');
          this.$emit('change', {
            isActive: this.isActive(path),
            postcodes: postcodes.filter(e => e !== ''),
            title: this.tTextTranslated(path).textContent || '',
          });
        }
        try {
          const a = this.parentIds.map(id => this.tTextTranslated(this.getShopAreaById(id)).textContent.trim());
          const b = [a.slice(0, -1).reverse(), a.slice(-1)].flat();
          if (b.length) {
            this.$awAnalytics[PUSH_CLICK_MAP]({
              clickType: CLICK_MAP_TYPE_AW_SHOP_AREA,
              mapAreas: b,
            });
          }
        } catch (err) {
          this.$logger.error(err);
        }
      },
    },
    async mounted () {
      /**
       * @type {XMLDocument}
       */
      const doc = new DOMParser().parseFromString(await (await fetch(AuchanShopAreaSprite)).text(), 'text/xml');

      const allAwShopArea = [...doc.children[0].children].flatMap(g => [...g.children]);

      this.symbols = allAwShopArea
        .filter(({ id }) => {
          const directChildrensUnderId = allAwShopArea.filter((e) => {
            return e.getAttribute(`${NS}:parentid`) === id;
          });
          if (!directChildrensUnderId.length) {
            return true;
          }
          return directChildrensUnderId.some((e) => {
            return e.getAttribute(`${NS}:visible`) === '1';
          });
        })
        .filter(s => s.getAttribute(`${NS}:visible`) === '1')
      ;

      this.reCalcViewBox(this.modelValue);
    },
    methods: {
      getShopAreaById (identifier) {
        identifier = identifier || this.modelValue;
        return this.symbols
          .find(e => e.id === identifier)
        ;
      },
      getChildrenById (identifier) {
        return this.symbols
          .filter(e => e.getAttribute(`${NS}:parentid`) === identifier)
        ;
      },
      async reCalcViewBox () {
        await nextTick(); // wait until childrens are filtered out
        const {
          x,
          y,
          width,
          height,
        } = this.$refs.svgElement.getBBox();
        this.viewBox = [x, y, width, height].join(' ');
      },
      isActive (shopArea) {
        const isDirectlyActive = shopArea.getAttribute(`${NS}:active`) === '1';
        return (isDirectlyActive || Boolean(this.getChildrenById(shopArea.id).find(this.isActive)));
      },
      sTransform (shopArea) {
        return this.tText(shopArea)?.getAttribute('transform');
      },
      tTextTranslated (shopArea) {
        const tTextElement = this.tText(shopArea);
        // NOTE: I do not yet know, why but eslint throws a warning when
        // SELECTOR is not a separate wariable and used directly in the
        // expression like this:
        // title = tTextElement?.querySelector?.(`text[systemLanguage="${this.$i18n.locale}"])?.textContent;
        //
        // Module Warning (from ./node_modules/eslint-loader/dist/cjs.js)
        // Cannot read property 'range' of null
        // Occurred while linting /home/node/app/shop/components/Common/Map/AwAuchanShopAreaMap.vue:121
        const SELECTOR = `text[systemLanguage="${this.$i18n.locale}"]`;
        const title = tTextElement?.querySelector?.(SELECTOR)?.cloneNode(true);
        if (!title) {
          this.$logger.warn('title is empty', tTextElement);
        } else {
          title.removeAttribute('systemLanguage');
        }
        return title || {};
      },
      tText (shopArea) {
        const e = shopArea.querySelector('switch');
        if (!e) {
          this.$logger.warn('shopArea is badly formatted', shopArea);
        }
        return e;
      },
      d (shopArea) {
        const e = shopArea?.querySelector('path')?.getAttribute('d');
        if (!e) {
          this.$logger.warn('shopArea is badly formatted', shopArea);
        }
        return e;
      },
      getTById (identifier) {
        return document.getElementById(this.uuid + identifier + 'translation');
      },
      hoverEffectToggle (identifier, val) {
        // NOTE: likely a WebKit issue, but we need to use optionalChaining

        this.getTById(identifier)?.classList?.toggle(this.$style.hoverEffect, val);
      },
    },
  };
</script>

<style module lang="scss" rel="stylesheet/scss">
.shopArea {
  fill: $color-mercury;
  stroke: $color-black;
  stroke-width: 1px;
  cursor: pointer;

  &.isActive {
    fill: $color-brand-primary;
  }

  &.isSelected {
    fill: $color-brand-secondary;
  }

  &Text {
    font-size: 18px;
    font-weight: $font-weight-bold;
    fill: $color-black;
    stroke: none;
    transition: font-size 0.2s ease-in-out;

    &.isActive {
      fill: $color-white;
      filter: drop-shadow(1px 1px 0 $color-black);
    }

    &.isSelected {
      fill: $color-white;
    }

    &.hoverEffect {
      font-size: 21px;
    }

    &.isNested {
      font-size: 7px;
    }

    &.isNested.hoverEffect {
      font-size: 9px;
    }
  }
}
</style>
